import { createUseStyles } from 'react-jss';
import { base } from '../../css/vars';

export default createUseStyles({
  frameColors: {
    '& > *:not(:last-child)': {
      marginBottom: base(),
    },
  },
});
